function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import ExtendableSpecs from 'swag-client-common/components/partials/extendable-specs';
import { Button } from 'swag-client-common/components/ui/button';
import ItemTitle from 'swag-client-common/components/partials/item-title';
import { SingleLineTextResizer } from 'swag-client-common/components/partials/single-line-text-resizer';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { SamplesDrawer } from '../../../../../popups/samples-drawer';
import { InstantQuotePopup } from '../../../../../popups/instant-quote-popup';
import { SpecsPopup } from '../../../../../popups/specs-popup';
import HeaderIcons from './components/header-icons';
import CSSclasses from './product-information.scss';
import animationClasses from './appear-with-height.anim.scss';
export const ProductInformationComponent = ({
  onSampleClick,
  onShowWarning,
  onClickInstantQuote,
  boxAllHiddenError = '',
  name,
  modifiedName,
  descr,
  productId,
  isPreorder,
  shouldShowSampleButton,
  isSamplePromo,
  onSpecsClick,
  showButtons = true,
  isOutOfStock,
  descriptionClass,
  extandableSpecs = false,
  hasInstantQuote = true,
  isLimitedEdition,
  specs,
  shouldShowSpecs,
  isPreBuiltLimitedCart
}) => {
  const handleInstantQuoteClick = e => {
    e.preventDefault();
    onClickInstantQuote();
  };
  const handleBuySampleClick = e => {
    e.preventDefault();
    if (!boxAllHiddenError) {
      return onSampleClick();
    }
    if (onShowWarning) {
      onShowWarning();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.container
  }, /*#__PURE__*/React.createElement(SamplesDrawer, null), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.main
  }, /*#__PURE__*/React.createElement(SingleLineTextResizer, {
    className: CSSclasses.titleSection,
    minFontSize: 1.4
  }, /*#__PURE__*/React.createElement(ItemTitle, {
    productName: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, name), isOutOfStock && /*#__PURE__*/React.createElement("span", {
      className: CSSclasses.warning
    }, "SOLD\xA0OUT"), isPreorder && /*#__PURE__*/React.createElement("span", {
      className: CSSclasses.warning
    }, "PREORDER")),
    productNameClass: CSSclasses.title,
    modifiedProductName: modifiedName,
    modifiedProductNameClass: CSSclasses.modifiedTitle,
    headingComponent: params => /*#__PURE__*/React.createElement("h1", _extends({}, params, {
      "data-product-id": productId
    }))
  }), /*#__PURE__*/React.createElement("div", {
    className: productDetailsClasses.onlyDesktop
  }, /*#__PURE__*/React.createElement(HeaderIcons, {
    className: CSSclasses.headerIcons
  }))), /*#__PURE__*/React.createElement("div", {
    className: classnames(CSSclasses.gray, CSSclasses.description, productDetailsClasses.text, descriptionClass)
  }, /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.onlyDesktop
  }, descr), extandableSpecs ? /*#__PURE__*/React.createElement(ExtendableSpecs, {
    specs: specs
  }) : shouldShowSpecs && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(productDetailsClasses.onlyMobileOrTablet, productDetailsClasses.specsContainer)
  }, /*#__PURE__*/React.createElement("span", {
    className: CSSclasses.specLink,
    onClick: onSpecsClick
  }, "See Full Description and Specs"), /*#__PURE__*/React.createElement(HeaderIcons, {
    className: CSSclasses.headerIcons
  })), /*#__PURE__*/React.createElement("span", {
    className: classnames(productDetailsClasses.onlyDesktop, CSSclasses.specLink),
    onClick: onSpecsClick,
    tabIndex: 0,
    onKeyDown: e => handleOnEnterPressed(e, onSpecsClick)
  }, "See specs")))), showButtons && /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [CSSclasses.buttonsContainer]: hasInstantQuote || shouldShowSampleButton
    })
  }, hasInstantQuote && /*#__PURE__*/React.createElement(Button, {
    onClick: handleInstantQuoteClick,
    dataButton: "Quote",
    variant: "contained",
    className: classnames(CSSclasses.button, CSSclasses.quote, {
      [CSSclasses.limitedEditionBtn]: isLimitedEdition
    }),
    withFocusOutline: true
  }, "Instant Quote"), shouldShowSampleButton && /*#__PURE__*/React.createElement(CSSTransition, {
    in: shouldShowSampleButton,
    timeout: 500,
    classNames: animationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleBuySampleClick,
    dataButton: "Sample",
    variant: "contained",
    disabled: Boolean(isSamplePromo),
    className: classnames(CSSclasses.button, CSSclasses.sample),
    withFocusOutline: true
  }, "Buy Sample"))), /*#__PURE__*/React.createElement(InstantQuotePopup, null), /*#__PURE__*/React.createElement(SpecsPopup, null));
};